// Routes owned by the APIUsageTemplate module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const aPIUsageTemplatePaths = {
    // Developer section
    apiUsageTemplates: '/developer/api-usage-templates',
} as const
